/**
 * File Upload Button Component
 * Triggers file selection dialog
 */

import { useRef } from 'react';

interface FileUploadButtonProps {
  onFilesSelected: (files: File[]) => void;
  disabled?: boolean;
  multiple?: boolean;
}

const FileUploadButton = ({
  onFilesSelected,
  disabled = false,
  multiple = true,
}: FileUploadButtonProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    if (files.length > 0) {
      onFilesSelected(files);
    }
    // Reset input to allow selecting same file again
    e.target.value = '';
  };

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        multiple={multiple}
        onChange={handleFileChange}
        className="hidden"
        aria-label="Прикачи файлове"
        disabled={disabled}
      />

      <button
        type="button"
        onClick={handleClick}
        disabled={disabled}
        className="w-8 h-8 flex items-center justify-center rounded-full text-discord-text-muted hover:text-discord-text-normal hover:bg-discord-interactive-hover/50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        aria-label="Прикачи файлове"
        title="Прикачи файлове"
      >
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="10" strokeWidth={2} />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v8m-4-4h8" />
        </svg>
      </button>
    </>
  );
};

export default FileUploadButton;
